<template>
  <div class="cooperation-container">
    <div class="banner-container">
      <div class="banner-content">
        <div class="banner-title">客户案例</div>
        <div class="banner-info">行业用户、明星产品的首选&nbsp;&nbsp;&nbsp;&nbsp;每日数亿量调用验证</div>
      </div>
    </div>
    <div class="cooperation-content">
      <div class="cooperation-bar" :class="{'cooperation-bar-fixed': secondNavFixed}">
        <div class="anchors-items">
          <div class="anchors-item" :class="{'active-anchors' : key == indexActive}"
            v-for="(item, key) in AnchorsItems" :key="key" @click="goAnchor(key)">
            {{item}}
          </div>
        </div>
      </div>
      <!-- <div class="cooperation-bar-place" v-if="secondNavFixed"></div> -->

      <div class="items-details">
        <div class="cooperation-title">经典案例</div>
        <div class="client-case-cooperation">
          <div class="icon-logo">
            <div class="logo-case-one"
              :style="{backgroundImage: 'url(' + clientCase.imgUrl + ')'}"></div>
            <div class="info-container" :class="{'no-blue' : clientCase.noBgBlue}">
              <div class="instance-title">{{clientCase.title}}</div>
              <div class="instance-info">{{clientCase.content}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="more-case-cooperation">
        <div class="cooperation-title">更多案例</div>
        <div class="more-case"
          :class="{'align-490' : moreCase.length == 1, 'align-365' : moreCase.length == 2}">
          <div class="more-case-logo"
            v-for="(item, index) in moreCase"
            :class="{'no-margin-right' : ((index + 1) % 5 == 0)}"
            :style="{backgroundImage: 'url(' + item + ')'}"
            :key="index">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ScrollManager from '@/components/open/common/ScrollManager';
import Cooperation from './js/Cooperation';

const SCROLL_TOP = 300;

export default {
  name: 'cooperationcontainer',
  data() {
    return {
      clientCase: Cooperation.clientCase.NETWORK,
      moreCase: Cooperation.moreCase.NETWORK,
      AnchorsItems: {
        NETWORK: '互联网',
        FINANCE: '金融',
        OTHER: '其他'
        // RETAIL: '零售',
        // ENTERPRISE: '政企',
        // FINANCE: '金融',
        // EDUCATIONAL: '教务',
        // MEDIA: '媒体',
        // INDUSTRIAL: '工业',
        // OTHER: '泛互'
      },
      secondNavFixed: false,
      indexActive: 'NETWORK'
    };
  },
  mounted() {
    ScrollManager.register(this.cooperationHandleMouseScroll);
    let key = this.$route.query.key || 'NETWORK';
    this.indexActive = key;
    this.clientCase = Cooperation.clientCase[key];
    this.moreCase = Cooperation.moreCase[key];
  },
  methods: {
    cooperationHandleMouseScroll(param) {
      if (param == null) {
        return;
      }
      let scrollTop = param.scrollTop;
      if (scrollTop < SCROLL_TOP) {
        this.secondNavFixed = false;
        return;
      }
      this.secondNavFixed = true;
    },
    goAnchor(key) {
      this.indexActive = key;
      this.clientCase = Cooperation.clientCase[key];
      this.moreCase = Cooperation.moreCase[key];
      document.documentElement.scrollTop = SCROLL_TOP;
    }
  },
  beforeDestroy() {
    ScrollManager.degister(this.cooperationHandleMouseScroll);
  }
};
</script>

<style lang="less" scoped>
.cooperation-container{
  background-color: rgb(245, 246, 247);
  div{
    box-sizing: border-box;
  }
  .banner-container{
    width: 100%;
    height: 360px;
    position: relative;
    color: #ffffff;
    background-image: url(./img/banner_partner.jpg);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    .banner-content{
      width: 1263px;
      padding-left: 30px;
      margin: 60px auto 0;
      .banner-title{
        font-size: 40px;
        font-family: 'PingFangSC-Medium';
        color: #000000;
        font-weight: 500;
        padding-top: 125px;
      }
      .banner-info{
        height: 32px;
        font-size: 18px;
        color: #3D485D;
        line-height: 32px;
        margin-top: 10px;
      }
    }
  }
  .cooperation-content {
    background-color: #F5F7FA;
    .cooperation-bar {
      width: 100%;
      min-width: 1200px;
      height: 60px;
      overflow: hidden;
      z-index: 2;
      background-color: #ffffff;
      border-bottom: 1px solid #eeeeee;
      .anchors-items {
        font-size: 0;
        text-align: center;
        .anchors-item {
          cursor: pointer;
          display: inline-block;
          margin: 0 45px;
          font-size: 17px;
          line-height: 50px;
          padding-top: 5px;
          &:hover {
            color: #0080FF;
            border-bottom: 4px solid #0080FF;
          }
          &.active-anchors{
            color: #0080FF;
            border-bottom: 4px solid #0080FF;
          }
        }
      }
      &.cooperation-bar-fixed{
        position: fixed;
        top: 63px;
        z-index: 1;
      }
    }
    .cooperation-title{
      font-family: 'PingFangSC-Semibold';
      font-size: 28px;
      color: #000000;
      text-align: center;
      line-height: 42px;
      font-weight: 500;
      margin-top: 120px;
      margin-bottom: 30px;
    }
    .client-case-cooperation{
      width: 1194px;
      margin: 0 auto;
      .icon-logo{
        position: relative;
        background: #FFFFFF;
        background-image: linear-gradient(180deg, #F5F7FA 0%, #FFFFFF 50%);
        border: 1px solid rgba(255,255,255,1);
        box-shadow: 2px 2px 8px 0px rgba(55,99,170,0.05), -2px -2px 8px 0px rgba(255,255,255,1);
        /* border: 1px solid rgba(21,21,21,0.05); */
        /* box-shadow: 0 10px 20px rgba(0,0,0,0.05), 0 6px 6px rgba(0,0,0,0.03); */
        margin-bottom: 26px;
        font-size: 0;
        .logo-case-one, .info-container{
          display: inline-block;
        }
        .logo-case-one{
          min-height: 240px;
          width: 360px;
          background-repeat: no-repeat;
          background-position: 0 center;
          height: 100%;
        }
        .info-container{
          background-image: url(./img/case/instance_background.png);
          background-repeat: no-repeat;
          background-position: 0 center;
          padding: 40px 42px;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          .instance-title{
            padding-bottom: 20px;
            font-size: 22px;
            color: #242526;
            text-align: left;
          }
          .instance-info{
            font-size: 16px;
            color: #212121;
            line-height: 1.8;
            text-align: justify;
          }
          &.no-blue{
            background: none;
          }
        }
      }
    }
    .more-case-cooperation{
      padding-bottom: 95px;
      .more-case{
        width: 1200px;
        margin: 0 auto;  
        font-size: 0;
        .more-case-logo{
          display: inline-block;
          width: 220px;
          height: 120px;
          margin-right: 25px;
          margin-bottom: 25px;
          background-position: center;
          background-repeat: no-repeat;
          /* border: #f2f2f2 1px solid; */
          /* box-shadow: 0 3px 7px rgba(0,0,0,0.03); */
          background: #FFFFFF;
          background-image: linear-gradient(180deg, #F5F7FA 0%, #FFFFFF 50%);
          border: 1px solid rgba(255,255,255,1);
          box-shadow: 2px 2px 8px 0px rgba(55,99,170,0.05), -2px -2px 8px 0px rgba(255,255,255,1);
          &.no-margin-right{
            margin-right: 0;
          }
        }
        &.align-490{
          padding-left: 490px;
        }
        &.align-365{
          padding-left: 365px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/cooperation/Cooperation.vue